import { render } from "./EditingMediafilesEditor.vue?vue&type=template&id=b7c19208"
import script from "./EditingMediafilesEditor.vue?vue&type=script&lang=js"
export * from "./EditingMediafilesEditor.vue?vue&type=script&lang=js"
script.render = render

export default script